import React from 'react';
import { Select, MenuItem, ListItemText, SelectProps } from '@mui/material';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { IComponentCss } from '../styles';

const css: IComponentCss = {
    checkIcon: {
        height: '20px',
        width: '20px',
        marginRight: '5px',
    },
    menuItem: {
        padding: '5px 6px',
    },
}

type SelectedValueItem = string | number;

export type SelectFieldProps<O, T extends SelectedValueItem[]> = Omit<SelectProps<T>, 'variant'> & {
    options: O[],
    renderOption: (item: O) => string,
    getOptionKey: (item: O) => SelectedValueItem,
    getOptionValue: (item: O) => SelectedValueItem,
}

export const MultipleSelect = <O, T extends SelectedValueItem[]>({ value, options, renderOption, getOptionKey, getOptionValue, ...selectProps }: SelectFieldProps<O, T>) => {
    return (
        <Select
            size='small'
            multiple
            displayEmpty
            {...selectProps}
            value={value}
        >
            {options.map(option =>
                <MenuItem
                    key={getOptionKey(option)}
                    value={getOptionValue(option)}
                    sx={css.menuItem}
                >
                    <CheckOutlinedIcon
                        sx={{
                            ...css.checkIcon,
                            visibility: value && value.indexOf(getOptionValue(option)) > -1 ? 'visible' : 'hidden',
                        }}
                    />
                    <ListItemText primary={renderOption(option)} />
                </MenuItem>,
            )}
        </Select>
    );
}